<div class="audit-page">
  <div class="audit-header">
    <h1>Audit events</h1>
    <p>The security event trail. Read-only, append-only.</p>
  </div>

  <div class="toolbar">
    <app-filter-select
      [(ngModel)]="typeFilter"
      name="typeFilter"
      (ngModelChange)="onFilterChange()"
      [options]="typeOptions"
      allLabel="All types"
    />

    <app-filter-select
      [(ngModel)]="outcomeFilter"
      name="outcomeFilter"
      (ngModelChange)="onFilterChange()"
      [options]="outcomeOptions"
      allLabel="All outcomes"
    />
  </div>

  <app-error-banner [message]="errorMessage()" />

  @if (isLoading()) {
    <p class="hint">Loading...</p>
  } @else if (events().length === 0) {
    <app-empty-state message="No audit events match this filter." />
  } @else {
    <table class="audit-table">
      <!-- Widths are inline, not scoped classes: Angular's emulated view encapsulation never
           attaches its scoping attribute to <col> elements, so a class-based rule here would
           silently never match and table-layout: fixed would fall back to 6 equal columns. -->
      <colgroup>
        <col style="width: 4%" />
        <col style="width: 20%" />
        <col style="width: 12%" />
        <col style="width: 22%" />
        <col style="width: 20%" />
        <col style="width: 22%" />
      </colgroup>
      <thead>
        <tr>
          <th></th>
          <th>Type</th>
          <th>Outcome</th>
          <th>Company</th>
          <th>Target</th>
          <th>Occurred</th>
        </tr>
      </thead>
      <tbody>
        @for (event of events(); track event.id) {
          <tr [class.row--open]="isExpanded(event.id)">
            <td class="expand-cell">
              <button
                type="button"
                class="expand-btn"
                [class.expand-btn--open]="isExpanded(event.id)"
                (click)="toggleRow(event.id)"
                [attr.aria-label]="isExpanded(event.id) ? 'Collapse row' : 'Expand row'"
              >
                <span class="material-icons">expand_more</span>
              </button>
            </td>
            <td class="truncate-cell">{{ event.type }}</td>
            <td><app-status-badge [status]="event.outcome" /></td>
            <td class="truncate-cell" [title]="event.companyId || ''">{{ truncate(companyLabel(event), COMPANY_MAX) }}</td>
            <td class="truncate-cell">{{ truncate(targetLabel(event), TARGET_MAX) }}</td>
            <td>{{ event.occurredAt | date: 'medium' }}</td>
          </tr>
          @if (isExpanded(event.id)) {
            <tr class="expanded-row">
              <td></td>
              <td colspan="5">
                <dl class="expanded-details">
                  <div>
                    <dt>Actor</dt>
                    <dd>{{ event.actorLabel || '—' }}</dd>
                  </div>
                  <div>
                    <dt>Target</dt>
                    <dd>{{ targetLabel(event) || '—' }}</dd>
                  </div>
                  <div>
                    <dt>Detail</dt>
                    <dd>{{ event.detail || '—' }}</dd>
                  </div>
                </dl>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>

    <div class="pagination">
      <div class="page-size-control">
        <span>Results per page</span>
        <app-page-size-select [sizes]="pageSizeOptions" [ngModel]="pageSize()" (ngModelChange)="onPageSizeChange($event)" name="pageSize" />
      </div>

      <div class="pagination-pill">
        <button class="page-nav" (click)="goToPage(page() - 1)" [disabled]="page() === 0">
          <span class="material-icons">chevron_left</span>
          Previous
        </button>
        @for (p of pageWindow; track $index) {
          @if (p === -1) {
            <span class="page-ellipsis">…</span>
          } @else {
            <button class="page-dot" [class.page-dot--active]="p === page()" (click)="goToPage(p)">
              {{ p + 1 }}
            </button>
          }
        }
        <button class="page-nav" (click)="goToPage(page() + 1)" [disabled]="page() === totalPages() - 1">
          Next
          <span class="material-icons">chevron_right</span>
        </button>
        <span class="pagination-divider"></span>
        <span class="pagination-summary">Showing {{ rangeStart }}–{{ rangeEnd }} of {{ totalCount() }} events</span>
      </div>
    </div>
  }
</div>
